
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import { Client, ICompleteResetPasswordModel, CompleteResetPasswordModel } from '@/services/api.service';
  import * as ValidateUtils from '@/utilities/validate.utils';

  @Component({})
  export default class CompleteResetPassword extends Vue {
    private token: string = '';
    private userid: string = '';
    private hasErrorMessage: boolean = false;
    private errorMessage: string = '';
    private password: string = '';
    private confirmPassword: string = '';

    private resetCompleted: boolean = false;
    
    private mounted() {
      // Extract the verifying token
      const token: string = this.$route.query.token as string;
      if (token !== null && token !== undefined) {
        this.token = token as string;
      }

      const userid: string = this.$route.query.userid as string;
      if (userid !== null && userid !== undefined) {
        this.userid = userid as string;
      }

    }
    private initResetPassword() {
      // check that the password are not blank, and match
      this.hasErrorMessage = false;
      if (this.password.length < 9) {
        this.errorMessage = 'The password must be at least 9 characters long';
        this.hasErrorMessage = true;
        return;
      }

      if (this.password !== this.confirmPassword) {
        this.errorMessage = 'The passwords do not match';
        this.hasErrorMessage = true;
        return;
      }

      // reset the password
      this.resetPassword();
    }

    public resetPassword() {
      // Call the api with the email address
      const me = this;
      me.hasErrorMessage = false;

      // @ts-ignore
      this.$Progress.start();
      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
      const model = new CompleteResetPasswordModel();
      model.newPassword = btoa(this.password);
      model.userId = this.userid;
      model.token = this.token;

      clientService
        .completeResetPassword(model)
        .then(data => {
          console.log('Resetting password completed ok');
          // @ts-ignore
          this.$Progress.finish();

          // check that the result was a boolean
          console.log(data);
          if (data.succeeded) {
            // @ts-ignore
            this.$awn.success('Reset password completed');
            me.resetCompleted = true;
          } else {
            // failed for some reason
            let errmsg = 'There was an error completing the password reset: ';
            if (data.errors !== undefined) {
              if (data.errors.length > 0) {
                errmsg += data.errors[0].description || '';
              }
            }
            // @ts-ignore
            this.$awn.alert(errmsg);
            me.errorMessage = errmsg;
            me.hasErrorMessage = true;
          }
        })
        .catch(error => {
          console.log('Resetting password failed');
          console.log(error);
          // @ts-ignore
          this.$Progress.finish();
          // @ts-ignore
          this.$awn.alert('There was an error requesting the password reset');
        });
    }
  }
